import { FilestackImage } from "@outschool/ui-components-shared";
import React from "react";

export function DefaultImage({
  imageUrl,
  imageSx = {},
}: {
  imageUrl?: string;
  imageSx?: any;
}) {
  return (
    <FilestackImage
      src={imageUrl}
      imageHeight={230}
      sx={{
        gridArea: "video",
        objectFit: "cover",
        width: "100%",
        ...imageSx,
      }}
    />
  );
}
